import React, { Component, useRef } from 'react';
import { connect } from 'react-redux'
import styles from './index.module.css'
import { PlusOutlined } from '@ant-design/icons';
import { actionCreators } from '../../store'
import ChatMessage from '../ChatMessage'

class MobileHome extends Component {
  async componentDidMount () {

  }
  render () {
    let active_date = this.props.active_date
    let active_topicid = this.props.active_topicid
    return (
      <div className={styles.mobile_home_container}>
        {
          active_date === '' && active_topicid === '' ? '' : (
            <div className={styles.mobile_home_add}>
              <PlusOutlined onClick={this.props.addNewConversation} />
            </div>
          )
        }
        <div className={styles.mobile_home_main}>
          <ChatMessage />
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    active_date: state.get('home').get('active_date'),
    active_topicid: state.get('home').get('active_topicid'),
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    addNewConversation () {
      dispatch(actionCreators.createNewConversationAction())
    }
  }

}

export default connect(mapStateToProps, mapDispatchToProps)(MobileHome)